import { render } from "./PlacesList.vue?vue&type=template&id=3a5113c7&scoped=true"
import script from "./PlacesList.vue?vue&type=script&lang=js"
export * from "./PlacesList.vue?vue&type=script&lang=js"

import "./PlacesList.vue?vue&type=style&index=0&id=3a5113c7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a5113c7"]])

export default __exports__